export const locale = {
    lang: 'tr',
    data: {
      'WEB_COMPANY_PROFILE': {
        'TIT_WCP': 'Web şirket profili',
        'TIT_WCP_DAT': 'Verilere erişim',
        'CHAN_INF':'Bilgi yükleniyor',
        'HELP':'yardım',
        'EnlaceWCP':'Şirket profiline girmek için bağlantıyı kopyalayın',
        'ClaveWCP':'Şirket profiline girmek için şifreyi kopyalayın',
        'PORDUC_CER':{
          '40':'3,0 Sertifikası',
          '1':'Onayla',
          '20':'Sertifika 2.0',

        },
        'ESTA_WEB_CP':{
          'false':'Yayınlamıyorum',
          'true':'Genel',
        },
        'MODAL':{
          'TIT_MOD':'Yayınlanmama sebebi nedir?',
           'BTN_CONT':'Devam',
           'BTN_CANC':'İptal',
           'RAISON_OBLIG': 'Devam etmek için yayınlanmama nedenini girmelisiniz',
           'TIT_CONDI_US':'Kullanım Koşulları',
           'TEX1_CONDI_US':'Şirket profili herkese açık hale getirildiğinde, yapılandırılan bilgilerle Great Place To Work(r) sayfasında yayınlanacaktır. Great Place to Work(r) ün içerikle ilgili hiçbir sorumluluğu yoktur, çünkü yayınlanan veriler, aynı şirketin kendisine yönelik platformlara yüklediği bilgilerin sonucudur.',
           'TEX2_CONDI_US':'Ayrıca şirket, bu bilgilerin Great Place To Work(r) tarafından sertifikalandırılmış çalışmak için en iyi şirketlerin yayılmasını artırmak için sözleşme yapılan çeşitli arama motorlarına yükleneceğini kabul eder',
           'TEX3_CONDI_US':'Şirket istediği zaman şirket profilini özel moda döndürebilir, bu da onun artık sertifikalı şirketler listesinde görünmemesine neden olur, ancak Great Place To Work(r) kaldıramaz arama motorlarının yaptığı indeksleme, bu nedenle, Great Place To Work ün birlikte çalıştığı farklı arama motorlarında bir süre şirket adının arama sonuçlarında görünmeye devam etmesi muhtemeldir.',
           'TEX4_CONDI_US':'Bu şirket profilinin yayınlanması veya yayınlanmaması tamamen şirketin sorumluluğundadır.',
           'REA_TEX_CONDI_US':'Onaylamak için lütfen aşağıdaki metni yazın',
           'NO_DISPO_ARCHI':'Dosya mevcut değil',
        }

      }
    }
};
